module.exports = __webpack_public_path__ + "img/6.Ford2020.58415140.png";